class ElegibilityEMDUIModel {
  constructor({
    emdVoucherExcedeed = undefined,
    emdVoucherFull = undefined,
    emdVoucherMinimun = undefined,
  } = {}) {
    this.emdVoucherExcedeed = emdVoucherExcedeed;
    this.emdVoucherFull = emdVoucherFull;
    this.emdVoucherMinimun = emdVoucherMinimun;
  }
}

export default ElegibilityEMDUIModel;